export default "__VITE_ASSET__c88e98a6__"